import { USER_ROLES } from '../constants.js';

/**
 * Question Status Enum
 */
export const QUESTION_STATUS = {
	NEW: 'new',
	ANSWERED: 'answered',
	WAITING: 'waiting',
};

/**
 * Get role-aware status configuration with translated labels
 * @param {string} userRole
 * @returns {Object}
 */
export function getStatusConfig(userRole) {
	const direct_t = window.wpcore?.direct_t ?? ((t) => t['en']);

	const config = {
		[QUESTION_STATUS.NEW]: {
			label: direct_t({ en: 'New', fr: 'Nouveau' }),
			class: 'bg-[#DBEAFE] text-[#193CB8]',
			icon: 'fi fi-rr-clock text-[#193CB8] text-xs'
		},
		[QUESTION_STATUS.ANSWERED]: {
			label: direct_t({ en: 'Answered', fr: 'Répondu' }),
			class: 'bg-success-100 text-success-700',
			icon: 'fi fi-rr-circle-check-2 text-success-700 text-xs'
		},
		[QUESTION_STATUS.WAITING]: {
			label: direct_t({ en: 'Waiting', fr: 'En attente' }),
			class: 'bg-warning-100 text-warning-500',
			icon: 'fi fi-rr-clock text-warning-500 text-xs'
		},
	};

	// For Coach, 'waiting' questions should look like 'new'
	if (userRole === USER_ROLES.COACH) {
		if (config[QUESTION_STATUS.WAITING] && config[QUESTION_STATUS.NEW]) {
			config[QUESTION_STATUS.WAITING] = { ...config[QUESTION_STATUS.NEW] };
		}
	}

	return config;
}
